import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { QuadroEnsinoComponent } from './quadro-ensino.component';
import { AuthGuard } from 'eddydata-lib';

const routes: Routes = [
  { path: '', component: QuadroEnsinoComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QuadroEnsinoRoutingModule { }
